
require('normalize.css/normalize.css');
require('./styles/index.scss');

import Point from './js/Point'

import Mouse from "./utils/mouse"
const canvas = document.querySelector('.main-canvas')
canvas.width = window.innerWidth * window.devicePixelRatio
canvas.height = window.innerHeight * window.devicePixelRatio
const ctx = canvas.getContext("2d")
ctx.globalAlpha = 1


let mouseX, mouseY

let radius = 100;
let time = 0;
let angle;


let points = []
let posX, posY;
let mouseClicked = false;

const randomIntFromInterval = (min, max) => { // min and max included 
  return Math.floor(Math.random() * (max - min + 1) + min)
}

let r = randomIntFromInterval(0, 255)
let g = randomIntFromInterval(0, 255)
let b = randomIntFromInterval(0, 255)
let rgb = `rgb(${r},${g},${b})`
console.log(rgb)

let rgbNew;




const createColors = () => {
  r = randomIntFromInterval(0, 255)
  g = randomIntFromInterval(0, 255)
  b = randomIntFromInterval(0, 255)
  rgb = `rgb(${r},${g},${b})`
} 

const createPoints = (x, y, gravity, rgb) => {
  points.push(new Point(ctx, x,y, 5, rgb, gravity))
  points.forEach(point => {
    point.draw()
    
  })

  points = points.filter(point => point.lifespan > 0)

}


let start = Date.now();
let raf;

// à chaque image : 60fps
const update = () => {

  if(Date.now()-start >= 30000){
    restart()
   
  }


    requestAnimationFrame(update)
    mouseX = ((Mouse.cursor[0] + 1) / 2) * canvas.width
    mouseY = ((Mouse.cursor[1] + 1) / 2) * canvas.height
   
    ctx.fillStyle = `#000000`;
    ctx.fillRect(0,0, canvas.width, canvas.height)
    ctx.globalCompositeOperation = 'lighter'
  
    
    ctx.fillStyle = `#000000`;
    ctx.globalAlpha = 0.01
    ctx.fillRect(0,0, canvas.width, canvas.height)
    ctx.globalAlpha =  Math.cos(1) * Math.sin();
  
    
    
    let gravity = randomIntFromInterval(-4, 10)
  
  
    createPoints(canvas.width/2, canvas.height/2, gravity, rgb)
  
    if(mouseClicked === true) {    
      let gravity = randomIntFromInterval(-4, 10)
      createPoints(posX, posY, gravity, rgbNew)
  
    }
  
    points = points.filter(point => point.lifespan > 0)
  
 
}
raf = requestAnimationFrame(update)


const restart = () => {
  start = Date.now();
  createColors()
  mouseClicked = true;
  ctx.clearRect(0,0,canvas.width, canvas.height)
  points = []
}

canvas.addEventListener('click', (e)=> {

  restart()
 
  // posX = e.offsetX
  // posY = e.offsetY
  // createColors()
})